/**
 *
 * @author Matthew Rawson @ 16/05/2018 14:19
 * @description
 * @notes
 */
import React from "react"
import PropTypes from "prop-types"
import {get, find, round, maxBy, range} from "lodash"
import styled from "styled-components"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang/index"
import {AnalysisContext, QuestionStatsContext} from "@irati/insights/context"
import {formatQuestionText} from "@irati/insights/utils/string"
import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import auth from "@irati/auth"

import {Tr, Td} from "../../ui/SimpleTable"
import {ChangeOverTime} from "../../ui/PillBadge"
import {AnswerBar} from "./"
import {COT_TOOLTIP_CONTEXT_QUESTION} from "../../utils/constants/changeOverTime"


export const ASSUMED_LIKERT_COUNT = 5
export const ASSUMED_LIKERT_RANGE = range(1, ASSUMED_LIKERT_COUNT + 1).map((title) => ({title, flush: true}))


const TdBar = styled(Td)`
  &&& {
    padding: 5px 1px;
    vertical-align: bottom;
  }
`
const ChangeOverTimeWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const AverageScoreWrapper = styled.div`
  margin-right: 5px;
`

const QuestionDataRow = ({question, formatMessage, ...props}) => {
  const idNamespace = id("QuestionDataRow", props)

  if (!question) return null

  const showCOT = doIHavePermission(["insights.changeOverTime"], auth.apps())

  const yScaleMax = get(maxBy(question.questionStats.answers, "count"), "count", 0)
  return (
    <AnalysisContext.Consumer>
      {({schedule: {preferences = {}} = {}}) => (
        <Tr
          id={id(question.uuid, idNamespace)}
          key={question.uuid}>
          <Td>{formatQuestionText(formatMessage, question, preferences.placeholders)}</Td>
          <Td right>{question.questionStats.timesAnswered}</Td>
          <Td right>{question.questionStats.timesSkipped}</Td>
          <Td bold right>
            <ChangeOverTimeWrapper>
              <AverageScoreWrapper> {round(question.questionStats.answersAverage, 1)} </AverageScoreWrapper>
              <QuestionStatsContext.Consumer>
                {({loading, historicalLoading}) => {
                  return showCOT && !loading && !historicalLoading && (
                    <ChangeOverTime
                      contextContentId={COT_TOOLTIP_CONTEXT_QUESTION}
                      currentScore={question.questionStats.answersAverage}
                      historicalScore={get(question.historicalQuestionStats, "answersAverage")} />
                  )
                }}
              </QuestionStatsContext.Consumer>
            </ChangeOverTimeWrapper>
          </Td>
          {ASSUMED_LIKERT_RANGE.map(({title: value}) => (
            /** using index for key as no other option available */
            <TdBar key={value}>
              <AnswerBar
                id={id(value, idNamespace)}
                yScaleMax={yScaleMax}
                total={question.questionStats.timesAnswered}
                count={get(find(question.questionStats.answers, {value}), "count", 0)} />
            </TdBar>
          ))}
        </Tr>
      )}
    </AnalysisContext.Consumer>
  )
}


QuestionDataRow.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  question: PropTypes.object
}
QuestionDataRow.defaultProps = {
  question: null
}

export default injectIntl(QuestionDataRow)
